import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../common/state/store";
import { ShopState } from "./ShopState";
import { ShopProductModel } from "./ShopModel";

const initialState: ShopState = {
  shopProductList: [],
  cart: [],
  cartPrice: 0,
  isDraft: false,
};

export const ShopSlice = createSlice({
  name: "shopSlice",
  initialState,
  reducers: {
    getShopProductList: state => {
      return {
        ...state,
      };
    },
    getShopProductListCompleted: (state, action: PayloadAction<ShopProductModel[]>) => {
      return {
        ...state,
        shopProductList: action.payload,
      };
    },
    getShopProductListDraft: state => {
      return {
        ...state,
      };
    },
    getShopProductListDraftCompleted: (state, action: PayloadAction<ShopProductModel[]>) => {
      return {
        ...state,
        shopProductList: action.payload,
      };
    },
    addToCart: (
      state,
      action: PayloadAction<{
        product: ShopProductModel;
        quantity: number;
        selectedOptions: { [key: string]: Array<{ name: string; addPrice: number | null }> };
      }>,
    ) => {
      const { product, quantity, selectedOptions } = action.payload;
      let allAddPrice = 0;
      for (const key in selectedOptions) {
        allAddPrice += selectedOptions[key].reduce((acc, cur) => {
          return acc + (cur.addPrice || 0);
        }, 0);
      }
      state.cartPrice += (product.price + allAddPrice) * quantity;
      const existingItem = state.cart?.find(
        item => item.product.id === product.id && JSON.stringify(item.selectedOptions) === JSON.stringify(selectedOptions),
      );

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.cart?.unshift({ product, quantity, selectedOptions });
      }
    },
    removeFromCart: (
      state,
      action: PayloadAction<{
        productId: string;
        selectedOptions: { [key: string]: Array<{ name: string; addPrice: number | null }> };
      }>,
    ) => {
      const { productId, selectedOptions } = action.payload;
      const existingItem = state.cart?.find(
        item => item.product.id === productId && JSON.stringify(item.selectedOptions) === JSON.stringify(selectedOptions),
      );

      if (existingItem) {
        let allAddPrice = 0;
        for (const key in selectedOptions) {
          allAddPrice += existingItem.selectedOptions[key].reduce((acc, cur) => {
            return acc + (cur.addPrice || 0);
          }, 0);
        }
        state.cartPrice -= existingItem?.product.price + allAddPrice;

        if (existingItem.quantity > 1) {
          existingItem.quantity -= 1;
        } else {
          state.cart = state.cart?.filter(item => item !== existingItem);
        }
      }
    },
    removeFromShopItem: (
      state,
      action: PayloadAction<{
        productId: string;
      }>,
    ) => {
      const { productId } = action.payload;
      const existingItem = state.cart?.find(item => item.product.id === productId);

      if (existingItem) {
        let allAddPrice = 0;
        for (const key in existingItem.selectedOptions) {
          allAddPrice += existingItem.selectedOptions[key].reduce((acc, cur) => {
            return acc + (cur.addPrice || 0);
          }, 0);
        }
        state.cartPrice -= existingItem?.product.price + allAddPrice;
        if (existingItem.quantity > 1) {
          existingItem.quantity -= 1;
        } else {
          state.cart = state.cart?.filter(item => item !== existingItem);
        }
      }
    },
    createOrder: state => {
      return {
        ...state,
      };
    },
    setIsDraft: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isDraft: action.payload,
      };
    },
  },
});

export const { getShopProductList, getShopProductListDraft, addToCart, removeFromCart, removeFromShopItem, setIsDraft } =
  ShopSlice.actions;

export const selectShopProductList = (state: RootState) => state.shopState.shopProductList;
export const selectCartItems = (state: RootState) => state.shopState.cart;
export const selectCartPrice = (state: RootState) => state.shopState.cartPrice;
export const selectIsDraft = (state: RootState) => state.shopState.isDraft;

export default ShopSlice.reducer;
